import React from 'react';
import { CheckCircle2, Clock, Layers, Award, Users, Building2, GraduationCap, Sparkles, CalendarDays, MessageCircle, Star } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import SEO from '../components/SEO';

const PHOTO = 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/syif6cvb_YOG07455-removebg-preview.png';
const WPP = 'https://wa.me/5561995792667?text=Ol%C3%A1!%20Tenho%20interesse%20na%20Forma%C3%A7%C3%A3o%20Revit%20Expert%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es.';

const MODULOS = [
  ['BIM | Mindset & Fundamentos', 'BIM01', '16h'], ['Revit | Setup — Instalação & Configuração', 'RVT02', '8h'],
  ['Revit | Fundamentos & Navegação', 'RVT03', '8h'], ['Revit | Arquitetura Essencial', 'RVT04', '16h'],
  ['Revit | Representação Gráfica & Documentação', 'RVT05', '16h'], ['Revit | Edificação Unifamiliar 2 Pavimentos', 'RVT06', '16h'],
  ['Revit | Render & Animação', 'RVT07', '8h'], ['Revit | Edificação Multifamiliar', 'RVT09', '12h'],
  ['Revit | Entrega, Publicação & Impressão', 'RVT08', '12h'], ['Revit | Advanced', 'RVT10', '32h'],
  ['Revit | Bibliotecas (Arq · Est · Inst)', 'RVT11', '16h'], ['Revit | Parametrização — Famílias', 'RVT12', '8h'],
  ['Revit | Parametrização — Compartilhados', 'RVT13', '8h'], ['Revit | Topografia', 'RVT14', '16h'],
  ['Revit | Projetos Complexos (Orgânica)', 'RVT15', '16h'], ['Autodesk | Forma Site Design', 'AUT16', '16h'],
  ['Revit | Power & Force', 'RVT17', '16h'], ['Revit | Estruturas — Concreto', 'RVT18', '8h'],
  ['Revit | Estruturas — Metálica', 'RVT19', '8h'], ['Revit | Tubulações — Água & Esgoto', 'RVT20', '16h'],
  ['Revit | HVAC & Conforto', 'RVT21', '16h'], ['Revit | Coordenação & Modelo Federado', 'RVT22', '32h'],
];

const PUBLICO = [
  [Building2, 'Arquitetos', 'Que desejam dominar o Revit e migrar do CAD para o BIM.'],
  [GraduationCap, 'Engenheiros', 'Que precisam desenvolver projetos multidisciplinares e colaborativos.'],
  [Users, 'Estudantes', 'Que querem ingressar no mercado já preparados para o BIM.'],
  [Layers, 'Empresas', 'Que desejam capacitar equipes e implantar BIM de forma estruturada.'],
];

const DIFERENCIAIS = [
  ['Metodologia desde 2008', 'Primeiro curso de Revit lançado no Brasil — 17+ anos refinando uma metodologia validada.'],
  ['Formação Completa', 'Arquitetura + Estruturas + Instalações + Coordenação em um único programa.'],
  ['Preparação p/ Certificação Autodesk', 'A formação dá condições para o aluno realizar a prova de certificação oficial da Autodesk.'],
  ['Suporte Especializado', 'Equipe técnica dedicada para tirar dúvidas e acelerar seu aprendizado.'],
  ['Conteúdo Atualizado', 'Sempre alinhado às últimas exigências do mercado BIM nacional e internacional.'],
  ['Ambiente EaD', 'Acesso às gravações para estudar quando e onde quiser, no seu ritmo.'],
];

const CRONOGRAMA = [
  ['01', 'Ago/2026', '08/08', '09/08'], ['02', 'Set/2026', '19/09', '20/09'], ['03', 'Out/2026', '24/10', '25/10'],
  ['04', 'Nov/2026', '21/11', '22/11'], ['05', 'Dez/2026', '19/12', '20/12'], ['06', 'Jan/2027', '23/01', '24/01'],
  ['07', 'Fev/2027', '20/02', '21/02'], ['08', 'Mar/2027', '20/03', '21/03'], ['09', 'Abr/2027', '24/04', '25/04'],
  ['10', 'Mai/2027', '22/05', '23/05'], ['11', 'Jun/2027', '19/06', '20/06'], ['12', 'Jul/2027', '17/07', '18/07'],
  ['13', 'Ago/2027', '21/08', '22/08'], ['14', 'Set/2027', '18/09', '19/09'], ['15', 'Out/2027', '16/10', '17/10'],
  ['16', 'Nov/2027', '20/11', '21/11'], ['17', 'Dez/2027', '18/12', '19/12'], ['18', 'Jan/2028', '22/01', '23/01'],
  ['19', 'Fev/2028', '19/02', '20/02'], ['20', 'Mar/2028', '18/03', '19/03'],
];

const DEPOIMENTOS = [
  ['Hoje consigo desenvolver projetos completos em Revit e aumentei muito minha produtividade.', 'Bruno Cunha', 'Arquiteto • Brasília/DF'],
  ['Consegui minha primeira oportunidade na área BIM após concluir a formação. A metodologia entrega o que promete.', 'Eugênio Reis', 'Engenheiro Civil • Recife/PE'],
  ['A formação mudou minha forma de projetar. Saí do CAD e hoje coordeno projetos multidisciplinares em BIM.', 'Camila Souza', 'Coordenadora BIM • SP'],
  ['Conteúdo denso, professor extremamente didático e uma comunidade incrível. Vale cada minuto.', 'Rafael Moura', 'Projetista • Curitiba/PR'],
  ['Saí do zero no Revit e em poucos meses entreguei meu primeiro projeto completo em BIM.', 'Patrícia Lopes', 'Arquiteta autônoma • BH'],
  ['O módulo de estruturas é excelente. Lançamento, armadura e documentação com profundidade.', 'Diego Almeida', 'Eng. Estrutural • Salvador'],
];

const BONUS = [
  'Biblioteca de Famílias Revit', 'Templates Profissionais', 'Materiais Complementares',
  'Comunidade Exclusiva', 'Atualizações da Formação', 'Eventos Online Exclusivos',
];

const CTA = ({ label = 'Quero conhecer a formação', testid }) => (
  <a href={WPP} target="_blank" rel="noopener noreferrer" data-testid={testid}>
    <Button className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-6 text-base rounded-xl shadow-lg shadow-red-900/30">
      <MessageCircle size={18} className="mr-2" />{label}
    </Button>
  </a>
);

const Section = ({ children, className = '' }) => (
  <section className={`py-16 md:py-20 px-4 lg:px-8 ${className}`}><div className="max-w-6xl mx-auto">{children}</div></section>
);

const RevitExpertPage = () => {
  return (
    <div className="bg-black min-h-screen" data-testid="revit-expert-page">
      <SEO title="Formação Revit Expert (320h) | AJ | BIM ACADEMY" description="A maior e mais completa Formação em Revit em língua portuguesa: Arquitetura, Estruturas, Instalações e Coordenação BIM. 22 módulos, 320 horas." />

      {/* HERO */}
      <section className="relative overflow-hidden bg-gradient-to-b from-zinc-950 to-black pt-20 pb-16 px-4 lg:px-8">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-center">
          <div>
            <Badge className="bg-red-600/20 text-red-400 border-red-500/30 mb-4">AJ | BIMACADEMY · Desde 2008</Badge>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight">
              Torne-se um <span className="text-red-500">Especialista Expert</span> em Revit
            </h1>
            <p className="text-gray-300 text-lg mt-5">
              A maior e mais completa <b className="text-white">Formação em Revit</b> em língua portuguesa —
              mais de <b className="text-white">320 horas</b>: Arquitetura, Estruturas, Instalações, Coordenação BIM e documentação profissional.
            </p>
            <ul className="mt-6 space-y-2 text-gray-300 text-sm">
              {['Aulas ao vivo e gravadas', 'Certificado de conclusão', 'Mentoria especializada', 'Comunidade exclusiva de alunos', 'Projetos reais desenvolvidos em Revit'].map((b, i) => (
                <li key={i} className="flex items-center gap-2"><CheckCircle2 size={16} className="text-red-500" />{b}</li>
              ))}
            </ul>
            <div className="mt-8"><CTA testid="hero-cta" /></div>
          </div>
          <div className="relative flex items-end justify-center">
            <div className="absolute inset-0 bg-red-600/10 blur-3xl rounded-full" />
            <img src={PHOTO} alt="Alexander Justi" className="relative h-[380px] w-auto object-contain drop-shadow-2xl" />
          </div>
        </div>
        <div className="max-w-6xl mx-auto grid grid-cols-3 gap-4 mt-12">
          {[['22', 'Módulos completos'], ['320h', 'Carga total'], ['4', 'Disciplinas BIM']].map(([n, l], i) => (
            <div key={i} className="bg-zinc-900/60 border border-zinc-800 rounded-xl p-5 text-center">
              <div className="text-3xl font-black text-red-500">{n}</div><div className="text-gray-400 text-xs mt-1">{l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* PÚBLICO */}
      <Section>
        <h2 className="text-3xl font-bold text-white text-center mb-3">Para quem é esta formação?</h2>
        <p className="text-gray-400 text-center mb-10 max-w-2xl mx-auto">Um programa estruturado para quem quer dominar o Revit em profundidade — independente do seu nível hoje.</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {PUBLICO.map(([Icon, t, d], i) => (
            <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-xl p-6">
              <Icon className="text-red-500 mb-3" size={26} />
              <h3 className="text-white font-semibold mb-1">{t}</h3><p className="text-gray-400 text-sm">{d}</p>
            </div>
          ))}
        </div>
      </Section>

      {/* MÓDULOS */}
      <Section className="bg-zinc-950">
        <h2 className="text-3xl font-bold text-white text-center mb-3">O que você vai aprender</h2>
        <p className="text-gray-400 text-center mb-10">22 módulos com 320 horas de conteúdo prático — do fundamento à coordenação BIM federada.</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {MODULOS.map(([nome, cod, ch], i) => (
            <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-lg p-4 flex items-start gap-3">
              <span className="text-red-500 font-black text-lg w-7 shrink-0">{String(i + 1).padStart(2, '0')}</span>
              <div><div className="text-white text-sm font-medium leading-snug">{nome}</div>
                <div className="text-gray-500 text-xs mt-1">{cod} · {ch}</div></div>
            </div>
          ))}
        </div>
      </Section>

      {/* DIFERENCIAIS */}
      <Section>
        <h2 className="text-3xl font-bold text-white text-center mb-10">Por que nossos alunos aprendem mais?</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {DIFERENCIAIS.map(([t, d], i) => (
            <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-xl p-6">
              <Sparkles className="text-red-500 mb-3" size={22} />
              <h3 className="text-white font-semibold mb-1">{t}</h3><p className="text-gray-400 text-sm">{d}</p>
            </div>
          ))}
        </div>
      </Section>

      {/* TURMA + CRONOGRAMA */}
      <Section className="bg-zinc-950">
        <div className="text-center mb-8">
          <Badge className="bg-red-600/20 text-red-400 border-red-500/30 mb-3">Turma aberta · Vagas limitadas</Badge>
          <h2 className="text-3xl font-bold text-white">Formato híbrido — 2 cursos em 1</h2>
          <p className="text-gray-400 mt-3 max-w-2xl mx-auto">Turma <b className="text-white">BR01/2026</b>: aulas <b className="text-white">ao vivo pela internet</b> + formação completa em <b className="text-white">EaD gravado</b>. Início em <b className="text-white">08 e 09 de agosto de 2026</b> — um final de semana por mês, sábados e domingos das 08h às 17h.</p>
        </div>
        <div className="overflow-x-auto border border-zinc-800 rounded-xl">
          <table className="w-full text-sm">
            <thead className="bg-zinc-900"><tr className="text-left text-gray-400">
              <th className="py-2 px-3">#</th><th className="py-2 px-3">Mês/Ano</th><th className="py-2 px-3">Sábado</th><th className="py-2 px-3">Domingo</th><th className="py-2 px-3">Carga</th>
            </tr></thead>
            <tbody>
              {CRONOGRAMA.map(([n, m, s, d], i) => (
                <tr key={i} className="border-t border-zinc-800/60 text-gray-300">
                  <td className="py-2 px-3 text-red-500 font-bold">{n}</td><td className="py-2 px-3">{m}</td>
                  <td className="py-2 px-3">{s}</td><td className="py-2 px-3">{d}</td><td className="py-2 px-3">16h</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-gray-500 text-xs mt-3 flex items-center gap-2"><CalendarDays size={14} />Datas planejadas para evitar feriados nacionais e períodos de férias. 20 encontros · 320h.</p>
        <div className="text-center mt-8"><CTA testid="turma-cta" /></div>
      </Section>

      {/* SOBRE */}
      <Section>
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <img src={PHOTO} alt="Alexander Justi" className="h-72 w-auto object-contain mx-auto" />
          <div>
            <Badge className="bg-red-600/20 text-red-400 border-red-500/30 mb-3">Quem é</Badge>
            <h2 className="text-3xl font-bold text-white mb-3">Prazer, eu sou o Alexander Justi</h2>
            <p className="text-gray-300 mb-4"><b className="text-white">Msc. Arquiteto e Urbanista</b>, especialista BIM atuando no mercado <b className="text-white">desde 2005</b>. Consultor estratégico de implementação BIM e referência nacional em capacitação profissional.</p>
            <ul className="space-y-1.5 text-gray-300 text-sm">
              {['Especialista BIM desde 2005', 'Consultor Estratégico de Implementação BIM', 'Autodesk Educator Expert', 'Revit Certified Professional'].map((x, i) => (
                <li key={i} className="flex items-center gap-2"><CheckCircle2 size={15} className="text-red-500" />{x}</li>
              ))}
            </ul>
            <div className="grid grid-cols-3 gap-3 mt-6">
              {[['2008', '1º curso Revit no BR'], ['+28', 'Anos de mercado'], ['+12k', 'Alunos formados']].map(([n, l], i) => (
                <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-lg p-3 text-center">
                  <div className="text-xl font-black text-red-500">{n}</div><div className="text-gray-500 text-[11px]">{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Section>

      {/* DEPOIMENTOS */}
      <Section className="bg-zinc-950">
        <h2 className="text-3xl font-bold text-white text-center mb-10">O que dizem nossos alunos</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {DEPOIMENTOS.map(([txt, nome, cargo], i) => (
            <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-xl p-6">
              <div className="flex gap-0.5 mb-3">{[...Array(5)].map((_, k) => <Star key={k} size={14} className="text-amber-400 fill-amber-400" />)}</div>
              <p className="text-gray-300 text-sm italic mb-4">“{txt}”</p>
              <div className="text-white font-semibold text-sm">{nome}</div><div className="text-gray-500 text-xs">{cargo}</div>
            </div>
          ))}
        </div>
      </Section>

      {/* BÔNUS */}
      <Section>
        <h2 className="text-3xl font-bold text-white text-center mb-3">Você também receberá</h2>
        <p className="text-gray-400 text-center mb-10">Stack de bônus exclusivos para acelerar seu domínio no Revit.</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {BONUS.map((b, i) => (
            <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-xl p-5 flex items-center gap-3">
              <Award className="text-red-500 shrink-0" size={20} /><span className="text-white text-sm font-medium">{b}</span>
            </div>
          ))}
        </div>
      </Section>

      {/* CTA FINAL */}
      <section className="py-20 px-4 bg-gradient-to-b from-black to-zinc-950 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Receba o programa completo</h2>
          <p className="text-gray-400 mb-8">Fale direto com nossa equipe pelo WhatsApp e receba a grade curricular, turmas, valores, bônus e o vídeo de apresentação.</p>
          <div className="flex flex-wrap items-center justify-center gap-6 mb-8 text-center">
            {[['+320h', 'Conteúdo prático'], ['22', 'Módulos'], ['7 dias', 'de garantia']].map(([n, l], i) => (
              <div key={i}><div className="text-2xl font-black text-red-500">{n}</div><div className="text-gray-500 text-xs">{l}</div></div>
            ))}
          </div>
          <CTA label="Falar no WhatsApp e receber o material" testid="final-cta" />
        </div>
      </section>
    </div>
  );
};

export default RevitExpertPage;
